<div>Chart-Work</div>
<div>
  <!--<div style="display: flex; justify-content: space-between;">
    <div id="main" style="width:44%; height: 410px;margin-bottom: 30px;"></div>
    <div id="mainRainfallmain" style="width: 54%;height: 410px;margin-bottom: 30px;margin-left: 10px;"></div>
  </div>-->
  <div style="display: flex; justify-content: space-around; flex-wrap: wrap;">
    <!-- Pie Chart -->
    <div echarts [options]="pieChartOptions" class="chart-container"></div>

    <!-- Bar Chart -->
    <div echarts [options]="barChartOptions" class="chart-container"></div>
  </div>
</div>

